import { useMemo } from 'react';
import { generateId } from '../utils';

export const useId = ({ id, prefix }: { id?: string; prefix?: string }) =>
  useMemo(() => id || generateId(prefix), [id, prefix]);
